import React from 'react';
import { educationalSections, frequentlyAskedQuestions } from '../data/educationalContent';

const relatedCalculators = [
  { name: 'Wells na gravidez: limites e algoritmo próprio', description: 'Por que o Wells tradicional não deve ser extrapolado para gestantes.', url: '/wells-na-gravidez/' },
  {
    name: 'Calculadora CURB-65',
    url: 'https://curb65.com.br/',
    context: 'A pneumonia pode estar entre as causas alternativas de dispneia e dor pleurítica; o CURB-65 organiza aspectos de gravidade na pneumonia.',
  },
  {
    name: 'Escore HEART',
    url: 'https://escoreheart.com.br/',
    context: 'Na avaliação de dor torácica, o HEART oferece uma estrutura própria para risco cardiovascular e não substitui a avaliação de TEP.',
  },
  {
    name: 'Clearance de creatinina',
    url: 'https://clearancecreatinina.com.br/',
    context: 'A função renal pode ser relevante ao considerar exames com contraste e medicamentos, incluindo anticoagulantes.',
  },
  {
    name: 'Calculadora de carga tabágica',
    url: 'https://cargatabagica.com.br/',
    context: 'A carga tabágica resume a exposição ao tabaco e acrescenta contexto à avaliação respiratória.',
  },
];

const otherCalculators = [
  ['Ânion gap', 'https://aniongap.com.br/'],
  ['Cálcio corrigido', 'https://calciocorrigido.com.br/'],
  ['Sódio corrigido', 'https://sodiocorrigido.com.br/'],
  ['Osmolaridade', 'https://osmolaridade.com.br/'],
  ['Superfície corporal', 'https://superficiecorporal.com.br/'],
  ['Escore de Alvarado', 'https://escorealvarado.com.br/'],
  ['Escala de Glasgow', 'https://calculadorawells.com.br/'],
];

function RelatedCalculators() {
  return (
    <section className="related-section">
      <div className="related-heading">
        <h2>Quais outras ferramentas podem complementar a avaliação?</h2>
        <p>
          Cada calculadora aborda uma pergunta clínica diferente; use sempre a
          ferramenta adequada ao contexto.
        </p>
      </div>
      <div className="related-list">
        {relatedCalculators.map((calculator) => (
          <article className="related-item" key={calculator.url}>
            <a href={calculator.url}>{calculator.name}</a>
            <p>{calculator.context}</p>
          </article>
        ))}
      </div>
      <div className="other-tools">
        <h3>Outras calculadoras</h3>
        <ul>
          {otherCalculators.map(([name, url]) => (
            <li key={url}>
              <a href={url}>{name}</a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function ContentSection() {
  return (
    <article className="education-content">
      <header className="education-intro">
        <h2>Como entender a escala de Wells para TEP e TVP?</h2>
        <p>
          A calculadora Wells separa duas versões clínicas que têm critérios,
          pesos e interpretações próprios. Esta página reúne os critérios
          pontuados, explica a probabilidade pré-teste e apresenta limites
          importantes para a leitura do resultado.
        </p>
      </header>

      {educationalSections.map((section, index) => (
        <section
          className={`education-section education-section-${index + 1}`}
          key={section.title}
        >
          <h2>{section.title}</h2>
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          {section.table && (
            <div className="comparison-table-wrap">
              <table className="comparison-table">
                <thead>
                  <tr>
                    <th scope="col">Aspecto</th>
                    <th scope="col">Wells para TEP</th>
                    <th scope="col">Wells para TVP</th>
                  </tr>
                </thead>
                <tbody>
                  {section.table.map(([aspect, tep, tvp]) => (
                    <tr key={aspect}>
                      <th scope="row">{aspect}</th>
                      <td>{tep}</td>
                      <td>{tvp}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      ))}

      <RelatedCalculators />

      <section className="faq-section">
        <h2>O que as pessoas perguntam sobre a escala de Wells?</h2>
        <div className="faq-list">
          {frequentlyAskedQuestions.map(({ question, answer }) => (
            <article className="faq-item" key={question}>
              <h2>{question}</h2>
              <p>{answer}</p>
            </article>
          ))}
        </div>
      </section>

      <aside className="medical-notice">
        <h2>Qual é o limite de uma calculadora Wells?</h2>
        <p>
          Este conteúdo é educativo e não substitui avaliação profissional,
          investigação diagnóstica nem protocolos locais. O escore Wells é uma
          ferramenta de probabilidade clínica pré-teste: não confirma nem
          exclui TEP ou TVP quando usado isoladamente.
        </p>
      </aside>
    </article>
  );
}

export default ContentSection;
